class Fn {
  /**
   * get random string
   * @returns {string}
   */
  static randomString() {
    let text = "";
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 18; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return "random" + text;
  }

  /**
   * render Image
   * @param url
   * @returns {Promise<any>}
   */
  static renderImgTag(url) {
    return new Promise((res, rej) => {
      if (url) {
        let img = new Image();

        img.onload = () => {
          res(img);
        };

        img.onerror = () => {
          rej(new Error(`Could not load image at ${url}`));
        };

        img.src = url;
      }
    });
  }

  /**
   * write style inside head
   * @param styleClass
   * @param content
   */
  static writeStyle(styleClass, content) {
    if ($(`.${styleClass}`).length === 0) {
      let oStyleEl = $(`<style class="${styleClass}" />`);
      $("head").append(oStyleEl);
    }

    let oStyle = $(`.${styleClass}`).eq(0);
    oStyle.html(content);
  }
}

export default Fn;
